import Axios from "../../configs/axios.config";

export const createReminder = (data) => Axios.post(`/common/reminder`, data);
export const updateReminder = (id, data) => Axios.put(`/common/reminder/${id}`, data);
export const getReminderList = (data) => Axios.get(`/common/reminder`, { params: data }).then(response => response.data.data);
export const getReminderDetail = (id) => Axios.get(`/common/reminder/${id}`).then(response => response.data.data);
export const deleteReminder = (id) => Axios.delete(`/common/reminder/${id}`);
